import register from 'preact-custom-element'
import { useEffect, useState } from 'preact/hooks'
import { addCartItem } from 'libs/cart'
import { openModal, hideModal } from 'helpers/dom'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import useInCart from 'hooks/useInCart'
import Icon from 'snippets/icon/icon'
import Price from 'snippets/price/price'
import Image from 'snippets/image/image'
import CustomModalDialog from 'snippets/custom-modal-dialog/custom-modal-dialog'

let devtools
if (process.env.NODE_ENV === 'development') {
  devtools = require('preact/devtools')
}

const selectors = {
  MODAL_ID: 'hot-spot-modal'
}

function HotSpotModal() {
  const [product, setProduct] = useState(null)

  const addToCart = async (item) => {
    const cartSingle = await addCartItem(item.id, {}, 1)
    if (cartSingle) {
      globalEmitter.emit(emitterProps.cart.add, cartSingle)
      hideModal(selectors.MODAL_ID)
    }
  }

  const classSizePrice = (variant) => {
    let classSize = 'text-sm'
    if (variant.compare_at_price && variant.compare_at_price !== 0) {
      const newClassSize = variant.compare_at_price > variant.price ? ' text-grey-300' : ' text-grey-700'
      classSize += newClassSize
    }
    return classSize
  }

  useEffect(() => {
    globalEmitter.on(emitterProps.product.hotSpot, (value) => {
      if (value) {
        setProduct(value.product)
        openModal(selectors.MODAL_ID)
      }
    })
  }, [])

  return (
    <CustomModalDialog
      id={selectors.MODAL_ID}
      type='slideup'
      classModal="items-end"
      classMain="w-full max-h-[calc(100%_-_70px)] overflow-auto"
      classClose="!p-0 !w-5 !h-5 !top-[18px] !right-4"
      scrollTarget=".js-content-modal-dialog"
      content={
        product &&
        <>
          <h6 className="p-4 text-center border-b border-default text-grey-1000">
            Shop the look
          </h6>
          <div className="p-4">
            <div className="flex items-center mb-4 bg-grey-100 last:mb-0">
              <a href={product.url} title={product.title} className="block w-32 h-32">
                <Image
                  key={product.id}
                  imageUrl={[product.featured_image]}
                  className="aspect-1"
                  imageClass="fit"
                />
              </a>
              <div className="flex flex-col flex-1 gap-1 p-4 pr-6">
                {!useInCart(product.initVariant).isAvailable &&
                  <p className="rounded bg-grey-200 px-1.5 py-0.5 text-xs font-medium text-grey-500 w-fit">
                    Sold Out
                  </p>
                }
                <a href={product.url} title={product.title} className="text-sm text-grey-1000 w-fit hover:underline">
                  {product.title}
                </a>
                <Price
                  className="flex flex-row-reverse gap-1 text-grey-700 w-fit"
                  classSize={classSizePrice(product.initVariant)}
                  price={product.initVariant.price}
                  originalPrice={product.initVariant.compare_at_price}
                  classColor="!text-error-content"
                />
              </div>
              <button
                type="button"
                onClick={() => addToCart(product.initVariant)}
                className={`w-7 h-7 p-[5px] border rounded-full ml-auto mr-4 ${useInCart(product.initVariant).isAvailable ? 'border-grey-1000' : 'border-default pointer-events-none'}`}
              >
                <Icon viewBox="0 0 22 22" name="icon-bag-plus" className={`w-full h-full ${useInCart(product.initVariant).isAvailable ? 'text-grey-1000' : 'text-grey-500'}`} />
              </button>
            </div>
          </div>
        </>
      }
    />
  )
}

register(HotSpotModal, 'hot-spot-modal')
